module.exports = __webpack_public_path__ + "static/img/ar.0f1ebe46.png";